import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { DatosEmpresaDenuncComponent } from 'src/app/pages/Denunciante/datos-empresa-denunc/datos-empresa-denunc.component';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { Persona } from 'src/app/models/Persona';
import { NavModalComponent } from 'src/app/pages/General/nav-modal/nav-modal.component';
import { ngClassAceptarModal, ngClassSalirModal, openModalMensaje, dscEtiquetaBtnAcepModal, dscEtiquetaBtnSalirModal } from 'src/app/general/variables';
import { Denunciante } from 'src/app/models/Denunciante';
import { ModalMensaje } from 'src/app/models/ModalMensaje';

@Component({
  selector: 'app-modal-datos-empresa',
  templateUrl: './modal-datos-empresa.component.html',
  styleUrls: ['./modal-datos-empresa.component.css']
})
export class ModalDatosEmpresaComponent implements OnInit {

  strDscTitulo = 'Datos Empresa';
  ngClassSalirModal = ngClassSalirModal;
  ngClassAceptarModal = ngClassAceptarModal;
  dscEtiquetaBtnAcepModal = dscEtiquetaBtnAcepModal;
  dscEtiquetaBtnSalirModal = dscEtiquetaBtnSalirModal;
  listEmpresa: Persona[] = [];

  @ViewChild(DatosEmpresaDenuncComponent) datosEmpresaDenuncC: DatosEmpresaDenuncComponent;
  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialog: MatDialog,
              public dialogRef: MatDialogRef<ModalDatosEmpresaComponent>) { }

  ngOnInit() {

    this.navModalC.setDatosNavModal2(this.strDscTitulo);

    this.listEmpresa = this.data.listaEmpresa;

  }

  _cerrar() {

    this.dialogRef.close();

  }

  _aceptarEmpresa() {

    const vFlgValida = this.datosEmpresaDenuncC.validarDatosEmpresa();
    const vDenunciante: Denunciante = this.datosEmpresaDenuncC.getDatosEmpresa();
    let vFlgError = false;

    if (!vFlgValida) {return; }

    this.listEmpresa.forEach(element => {

      if (element.cpersonaRazonsocial == vDenunciante.personaComplemento.cpersonaRazonsocial) {

        vFlgError = true;



      }

    });

    if (vFlgError) {

      openModalMensaje(this.strDscTitulo, 'la empresa ya fue ingresada, por favor verifique', this.dialog);

      return;

    }

    this.dialogRef.close(vDenunciante);

  }

}
